import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_section,
  delete_section,
  get_section,
  get_section_list,
  update_section,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  sections: [],
  sectionlist: [],
  sectionfilterlist: [],
  school_id:"",
  class_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    nick_name: "",
  },
};
// Async Thunks for API Calls
export const fetchSectionList = createAsyncThunk(
  'classes/fetchSectionlist',
  async ({school_id,class_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_section_list(school_id,class_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls
export const fetchfiltersectionList = createAsyncThunk(
  'classes/fetchfiltersectionList',
  async ({school_id,class_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_section_list(school_id,class_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchSection = createAsyncThunk(
  "section/fetchSection",
  async ({ page, page_size,school_id,filter_fields,class_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_section(page, page_size,school_id,filter_fields,class_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createSection = createAsyncThunk(
  "section/createSection",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_section(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateSection = createAsyncThunk(
  "section/updateSection",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_section(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSection = createAsyncThunk(
  "section/deleteSection",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_section({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const sectionSlice = createSlice({
  name: "sections",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },

    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, school_class, name, nick_name } = action.payload;
      state.formData = { id, school_class, name, nick_name };
    },

    resetFormData(state) {
      state.formData = {
        name: "",
        nick_name: "",
      };
    },
    setSection(state, action) {
      state.sections = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
    setClassId(state, action) {
      state.class_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    // section list 
    .addCase(fetchSectionList.fulfilled, (state, action) => {
      state.sectionlist = action.payload.data;
    })
    .addCase(fetchSectionList.rejected, (state, action) => {
      state.sectionlist = [];
    })
    .addCase(fetchfiltersectionList.fulfilled, (state, action) => {
      state.sectionfilterlist = action.payload.data;
    })
    .addCase(fetchfiltersectionList.rejected, (state, action) => {
      state.sectionfilterlist = [];
    })
      // Fetch Classes
      .addCase(fetchSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createSection.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createSection.fulfilled, (state, action) => {
        state.addLoading = false;
        state.classes = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createSection.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateSection.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateSection.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateSection.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleteSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSection.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteSection.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setSection,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  setClassId
} = sectionSlice.actions;
export default sectionSlice.reducer;
